import SaveIcon from "@mui/icons-material/Save";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";

export function SaveButton(props: { onClick: () => void }) {
    return (
        <IconButton color="info" onClick={props.onClick}>
            <SaveIcon />
        </IconButton>
    );
}

export function CloseButton(props: { onClick: () => void }) {
    return (
        <IconButton color="warning" onClick={props.onClick}>
            <CloseIcon />
        </IconButton>
    );
}

export function EditButton(props: { onClick: () => void }) {
    return (
        <IconButton color="warning" onClick={props.onClick}>
            <EditIcon />
        </IconButton>
    );
}
